export default __webpack_public_path__ + "static/media/03_photo.9c2e7124.jpg";